/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCustomerProducts = /* GraphQL */ `
  query GetCustomerProducts($customer_code: String!, $product_id: String) {
    getCustomerProducts(
      customer_code: $customer_code
      product_id: $product_id
    ) {
      code
      data {
        products {
          code
          description {
            en
            es
          }
          enabled
          name
          status
        }
      }
      message
    }
  }
`;